/**
 * GTM / GA4 事件追蹤工具（change: gtm-deeplink-click-tracking）。
 *
 * 只負責把事件 push 到 GTM 的 window.dataLayer，GA4 的 Measurement ID、事件標記等都在 GTM 後台設定，
 * 程式端不放 gtag。追蹤屬於「附加行為」，任何失敗（dataLayer 被覆寫、GTM 被擋、push 拋例外）
 * 一律靜默吞掉，不得影響深連結消費或送訊息主流程。
 *
 * 隱私：事件參數只應包含 channel 等彙總維度，不得放入 promptText、帳號、payload 密文；
 * 此檔會自動附加 env（sit/uat/prod），讓共用同一個測試容器的 SIT 與 UAT 數據可被區分。
 */

/** 目前環境名稱（build 時由 REACT_APP_ENV_NAME 注入：local/dev/sit/uat/prod）。 */
const ENV_NAME = process.env.REACT_APP_ENV_NAME || '';

/**
 * 將事件 push 至 GTM dataLayer。
 *
 * @param {string} name 事件名稱（例如 deeplink_send_triggered），對應 GTM 自訂事件觸發器
 * @param {Object} [params] 事件參數（例如 { channel }）；不得含敏感內容
 */
export function trackEvent(name, params = {}) {
  try {
    if (typeof window === 'undefined' || !name) return;
    window.dataLayer = window.dataLayer || [];
    // env 放在 params 之後，避免呼叫端誤帶 env 蓋掉真實環境值
    window.dataLayer.push({ event: name, ...params, env: ENV_NAME });
  } catch (error) {
    // 追蹤失敗不得影響主流程，刻意不記 log、不重拋
  }
}
